import HeaderContainer from "../../components/HeaderContainer";
import Header from "../../components/Header";
import Navbar from "../../components/Navbar";
import ContentWrapper from "../../components/ContentWrapper";
import SubNavbarPlano from "../../components/SubNavbarPlano";
import BoxPlanoInPogs from "./_components/BoxPlanoInPogs";

const PlanoInPogs = () => {
  return (
    <>
      <HeaderContainer>
        <Header />
        <Navbar idx={1} />
      </HeaderContainer>

      <ContentWrapper>
        <SubNavbarPlano idx={1} />
        <BoxPlanoInPogs />
      </ContentWrapper>
    </>
  );
};

export default PlanoInPogs;
